/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Properties_CreatedInputs */

const cs_import_stat_properties_created = /** @type {(inputs: Import_Stat_Properties_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vytvořeno: ${i?.count}`)
};

const en_import_stat_properties_created = /** @type {(inputs: Import_Stat_Properties_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Created: {count}" |
*
* @param {Import_Stat_Properties_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_properties_created = /** @type {((inputs: Import_Stat_Properties_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Properties_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_properties_created(inputs)
	return cs_import_stat_properties_created(inputs)
});